import React, { useLayoutEffect } from "react"
import { css } from "@emotion/react"

export interface MobilePageLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode
}

export const MobilePageLayout = ({
    children,
    ...props
}: MobilePageLayoutProps) => {
    useLayoutEffect(() => {
        document.body.style.cssText = `
            height: 100%;
            height: -moz-available;
            height: -webkit-fill-available;  
            height: fill-available;
        `
    }, [])

    return (
        <div
            css={css`
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            `}
            {...props}
        >
            {children}
        </div>
    )
}
